import { useState, useEffect } from 'react';
import { useAdminContext } from '../../../../api/AdminContext';
import useQuestionBankContext from '../../../../api/QuestionBankContext';
import { useLoadingContext } from '../../../../context/LoadingContext';
import { scrollToTop } from '../../../../utils/helpers';
import CurrentBankNotice from '../CurrentBankNotice';
import QuestionsManagerContainer from '../QuestionsManagerContainer';
import QuestionBuilderForm from './QuestionBuilderForm';
import Warnings from './Warnings';
import type { CreateQuestionData } from '../../../../data/interface-question';
import type { QuestionBankID } from '../../../../data/interface-question-bank';

const QuestionBuilder = () => {
	const { setLoading, setLoadingMessage } = useLoadingContext();
	const { categories, getCategories } = useQuestionBankContext();
	const { createQuestion, setAdminQuestions } = useAdminContext();
	const [formKey, setFormKey] = useState(0); // Add key to force re-render
	// #region QUESTION BANK ID
	const lsBankID = localStorage.getItem('questionBankID') as QuestionBankID;
	const [questionBankID, setQuestionBankID] = useState<QuestionBankID>(
		lsBankID !== null ? lsBankID : 'enurm'
	);
	const handleQBankChange = (v: QuestionBankID) => {
		setQuestionBankID(v);
		setAdminQuestions(undefined);
		// resetForm();
	};
	// #endregion

	const handleSubmit = (formData: CreateQuestionData) => {
		setLoadingMessage('Submitting question...');
		setLoading(true);

		createQuestion(formData)
			.then(() => {
				setLoading(false);
				setFormKey((prev) => prev + 1); // Force form re-render
				scrollToTop();
			})
			.catch((error: any) => {
				console.error('Error creating question:', error);
				setLoading(false);
			});
	};

	const clearForm = () => {
		setFormKey((prev) => prev + 1); // Force form re-render
		scrollToTop();
	};

	useEffect(() => {
		if (categories === undefined || categories.length === 0) {
			getCategories()
				.then(() => {
					console.info('Categories loaded');
				})
				.catch((error) => {
					console.error('Error loading categories:', error);
				});
		}
		scrollToTop();
	}, []);

	return (
		<QuestionsManagerContainer title='Add Questions'>
			<CurrentBankNotice
				examID={questionBankID}
				handleQBankChange={(v: QuestionBankID) => handleQBankChange(v)}
				showAddQuestionBtn={false}
			/>

			<QuestionBuilderForm
				key={formKey}
				questionBankID={questionBankID}
				onSubmit={handleSubmit}
				onClear={clearForm}
			/>

			<Warnings
				showWarning={false}
				question=''
				source={undefined}
				categoryID={undefined}
				answer=''
				option1=''
				option2=''
				option3=''
				explanation=''
				fuentes=''
			/>
		</QuestionsManagerContainer>
	);
};
export default QuestionBuilder;
